var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:[ true ? _vm.useClass : ''],attrs:{"disabled":_vm.disabled},on:{"click":_vm.buttonClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }